// Venmo accepts prefilled payments via public URL params (txn/recipients/amount/note).
export function venmoPayHref(handle, amount, note) {
  const user = (handle || "").trim().replace(/^@/, "");
  if (!user) return "#";
  const p = new URLSearchParams({ txn: "pay", recipients: user, audience: "private" });
  if (amount) p.set("amount", Number(String(amount).replace(/[^0-9.]/g, "")).toFixed(2));
  if (note) p.set("note", note);
  return `https://account.venmo.com/pay?${p.toString()}`;
}

export function venmoProfileHref(handle) {
  return `https://venmo.com/u/${(handle || "").trim().replace(/^@/, "")}`;
}

export function firstName(user) {
  return ((user?.name || user?.legal_name || "").trim().split(/\s+/)[0]) || "";
}
